import { notification, Pagination } from "antd";
import React from "react";
import { useEffect, useState } from "react";

import DeleteConfirmation from "../../../components/common/ConfirmationModal/DeleteConfirmation";
import DeleteIcon from "../../../components/icons/DeleteIcon";
const SrtEcryption = (props) => {
  const { fetchSecretValues, deleteSecretValue, loader, setLoader } = props;
  const [activePage, setActivePage] = useState(1);
  const [settingsRecordsPerPage] = useState(20);
  const [totalCount, setTotalCount] = useState(0);

  const [secretValuesList, setSecretValuesList] = useState([]);
  const [deleteModalOpen, setDeleteModalOpen] = useState(false);
  const [data, setData] = useState({});

  const handlePageChange = (current) => {
    setActivePage(current);
  };

  const fetchSecretValuesList = async () => {
    setLoader(true);
    const data = await fetchSecretValues({
      page_no: activePage,
      limit: 20,
    });
    if (data?.value.success) {
      setTotalCount(data?.value?.srtSecretsCount);
      setSecretValuesList(data?.value?.data);
    } else {
      notification["error"]({ message: data?.value?.message });
    }
    setLoader(false);
  };

  useEffect(() => {
    fetchSecretValuesList();
  }, [activePage]);

  const deleteSecretValueFunction = async () => {
    const { value } = await deleteSecretValue({
      secret_value: data.secret_value,
      type: "delete",
      arn: data.secret_arn,
      region: data.region,
    });
    if (value.success) {
      notification["success"]({ message: value.message });
    } else {
      notification["error"]({ message: value.message });
    }
    setDeleteModalOpen(false);
    fetchSecretValuesList();
  };
  const handleSecretValueDelete = (data) => {
    setDeleteModalOpen(true);
    setData(data);
  };
  return (
    <React.Fragment>
      <DeleteConfirmation
        deleteConfirmModalOpen={deleteModalOpen}
        setDeleteConfirmModalOpen={setDeleteModalOpen}
        deleteFunction={deleteSecretValueFunction}
      />
      <div className="col-md-9">
        <div className="left-block">
          <h4 className="title-sm-t">SRT keys</h4>
        </div>

        <div className="border-block mt-3">
          <div className="row">
            <div className="col-md-12">
              <div className="table-resposive table-container user-management-table">
                <table className="table">
                  <>
                    <thead>
                      <tr>
                        <th>Secret Value</th>
                        <th>Region</th>
                        <th style={{ textAlign: "right" }}></th>
                      </tr>
                    </thead>
                    <tbody>
                      {loader ? (
                        <>
                          <tr>
                            <td colSpan="7">
                              <div className="text-center  pt-5 pb-5">
                                <h3>Fetching secret value list</h3>
                              </div>
                            </td>
                          </tr>
                        </>
                      ) : (
                        <>
                          {secretValuesList?.length ? (
                            secretValuesList?.map((data, index) => {
                              return (
                                <tr key={data?._id}>
                                  <td>{data?.secret_value}</td>
                                  <td>{data?.region}</td>
                                  <td>
                                    <div style={{ textAlign: "right" }}>
                                      <a onClick={() => handleSecretValueDelete(data)}>
                                        <DeleteIcon />
                                      </a>
                                    </div>
                                  </td>
                                </tr>
                              );
                            })
                          ) : (
                            <>
                              <tr>
                                <td colSpan="7">
                                  <div className="text-center  pt-5 pb-5">
                                    <h3>No secret value found</h3>
                                  </div>
                                </td>
                              </tr>
                            </>
                          )}
                        </>
                      )}
                    </tbody>
                  </>
                  <tfoot></tfoot>
                </table>
              </div>
            </div>
          </div>
        </div>

        <Pagination
          showSizeChanger={false}
          current={activePage}
          pageSize={settingsRecordsPerPage}
          onChange={handlePageChange}
          total={totalCount}
          className="text-center mt-3"
        />
      </div>
    </React.Fragment>
  );
};
export default SrtEcryption;
